import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Grid, Button, Spin } from 'antd';

const { Title, Paragraph } = Typography;
const { useBreakpoint } = Grid;

const API_BASE = process.env.REACT_APP_API_BASE || '';
const BRAND = 'var(--brand-primary, #222957)';

// 預設品牌故事（後台未填時顯示）— 星河耀眼原創文案
const DEFAULT_TITLE = '品牌故事';
const DEFAULT_CONTENT = [
  '星河耀眼，始於一個很單純的念頭：每個人身上都藏著一片屬於自己的星空。',
  '我們相信，天上的星、地上的石，其實是同一種能量的兩種樣子。於是我們把五行的平衡與生命靈數的線索，化作一顆顆水晶，串成只屬於你的那條手鏈。',
  '每一條作品都不是現成的商品，而是從你的出生年月、你此刻缺的與想補的開始，一顆一顆為你挑選、為你排列。金木水火土在腕間流轉，讓對的能量，剛好落在你身上。',
  '我們不追求華麗，只在意剛剛好——剛好的顏色、剛好的重量、剛好在你需要的時候，給你一點安定的力量。',
  '願這片星河，陪你走過每一個平凡卻珍貴的日子。',
].join('\n\n');

export default function About() {
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState(DEFAULT_TITLE);
  const [content, setContent] = useState('');

  useEffect(() => {
    let alive = true;
    fetch(`${API_BASE}/api/settings/shop`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (!alive) return;
        if (d && typeof d === 'object') {
          setTitle((d.about_title && d.about_title.trim()) || DEFAULT_TITLE);
          setContent((d.about_content && d.about_content.trim()) || DEFAULT_CONTENT);
        } else {
          setContent(DEFAULT_CONTENT);
        }
      })
      .catch(() => { if (alive) setContent(DEFAULT_CONTENT); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);

  const paragraphs = (content || DEFAULT_CONTENT)
    .split(/\n{2,}|\n/)
    .map((s) => s.trim())
    .filter(Boolean);

  return (
    <div style={{ width: '100%', minHeight: '100%', background: isMobile ? '#fff' : '#F9FAFD' }}>
      <div style={{ maxWidth: 820, margin: '0 auto', padding: isMobile ? '24px 18px 40px' : '48px 32px 72px' }}>
        <Title level={1} style={{ fontSize: isMobile ? 24 : 30, color: BRAND, fontWeight: 800, letterSpacing: 1, marginBottom: isMobile ? 20 : 28 }}>
          {title}
        </Title>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '60px 0' }}><Spin /></div>
        ) : (
          <div style={{
            background: '#F9FAFD', border: '1px solid #E5E7F5', borderRadius: 16,
            padding: isMobile ? '20px 18px' : '32px 36px',
          }}>
            {/* 服務說明（固定顯示，置於最前）：明確說明本站用途與登入目的 */}
            <Paragraph
              style={{
                fontSize: isMobile ? 15 : 16, lineHeight: 2, color: '#2C3674', fontWeight: 600,
                marginBottom: 20, paddingBottom: 16, borderBottom: '1px dashed #E5E7F5',
              }}
            >
              星河耀眼 ShiningStar Jewelry 是台灣的客製水晶手鍊品牌，提供客製與現貨天然水晶手鍊：
              依你的出生年月、五行平衡與生命靈數，為你配色設計、手作出貨。
              使用 Google 或 LINE 登入後，即可建立與查詢訂單、追蹤製作進度、管理收件資料與收藏願望清單。
            </Paragraph>

            {paragraphs.map((p, i) => (
              <Paragraph
                key={i}
                style={{ fontSize: isMobile ? 15 : 16, lineHeight: 2, color: '#2C3674', marginBottom: 16 }}
              >
                {p}
              </Paragraph>
            ))}

            <div style={{ textAlign: 'center', marginTop: isMobile ? 20 : 32 }}>
              <Button
                size="large"
                onClick={() => navigate('/custom')}
                style={{
                  borderRadius: 24, fontWeight: 700, height: isMobile ? 44 : 50,
                  paddingInline: isMobile ? 26 : 40, background: BRAND, color: '#fff', border: 'none',
                }}
              >
                開始客製你的手鏈 ✨
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
